import { InterviewAnswer, MedicalInterviewContent } from '../types';

export const medicalInterviewContentsMock: MedicalInterviewContent[] = [
  {
    id: 1,
    title: '基本情報',
    interviews: [
      {
        id: 1,
        label: '身長',
        title: '身長',
        unit: 'cm',
        required: true,
        inputType: 'text'
      },
      {
        id: 2,
        label: '体重',
        title: '体重',
        unit: 'kg',
        required: true,
        inputType: 'text'
      }
    ]
  },
  {
    id: 2,
    title: '診療に関わる情報',
    interviews: [
      {
        id: 3,
        label: '今回の受信目的は、最近受けた怪我の治療ですか？',
        title: '受信の目的',
        required: true,
        inputType: 'button',
        isQuestion: true,
        contents: [
          {
            id: 1,
            label: 'はい'
          },
          {
            id: 2,
            label: 'いいえ'
          }
        ]
      },
      {
        id: 4,
        label: '受信の目的、解決したい問題は何ですか？',
        title: '解決したい問題',
        required: true,
        inputType: 'button',
        isQuestion: true,
        contents: [
          {
            id: 1,
            label: '痛み'
          },
          {
            id: 2,
            label: '痺れる'
          },
          {
            id: 3,
            label: '疲れやすい'
          },
          {
            id: 4,
            label: 'むくみ'
          },
          {
            id: 5,
            label: '姿勢が気になる'
          },
          {
            id: 6,
            label: '足の形が気になる'
          },
          {
            id: 7,
            label: '歩行に問題がある'
          },
          {
            id: 8,
            label: 'その他'
          }
        ],
        sub: {
          id: 1,
          label: 'その他を選ばれた方はご記載ください。',
          inputType: 'text'
        }
      },
      {
        id: 5,
        label: 'タバコについて',
        title: 'タバコについて',
        required: true,
        inputType: 'button',
        isQuestion: true,
        contents: [
          {
            id: 1,
            label: '吸ったことがない'
          },
          {
            id: 2,
            label: '吸っている'
          },
          {
            id: 3,
            label: 'やめた'
          }
        ],
        sub: {
          id: 1,
          label: '吸っている・やめた方は、喫煙年数を教えてください。',
          inputType: 'select',
          contents: [
            {
              id: 1,
              label: '1~5年'
            },
            {
              id: 2,
              label: '6~10年'
            },
            {
              id: 3,
              label: '11~15年'
            },
            {
              id: 4,
              label: 'それ以上'
            }
          ]
        }
      },
      {
        id: 6,
        label: '気になる足の症状がありましたら、画像を送信してください。',
        title: 'アップロードした画像',
        inputType: 'image',
        isQuestion: true
      }
    ]
  }
];

export const demoRequestData: InterviewAnswer[] = [
  {
    id: 1,
    text: '176'
  },
  {
    id: 2,
    text: '65'
  },
  {
    id: 3,
    value: 1,
    label: 'はい'
  },
  {
    id: 4,
    value: 3,
    label: '疲れやすい'
  },
  {
    id: 5,
    value: 2,
    label: '吸っている'
  },
  {
    id: 6,
    text: '',
    label: 'img_1234.jpg'
  }
];
